export default {
  outerDimensions: 'components.views.forms.generate-product.outer-dimensions',
  preferredSpaceBetweenElements:
    'components.views.forms.generate-product.preferred-space-between-elements',
  preferredMaximumNumberOfElements:
    'components.views.forms.generate-product.preferred-maximum-number-of-elements'
}
